/* @jsx h */
import { defineComponent, h, computed } from "vue";
import { useMenu } from "@app/vue/providers/index";
import { EventReservationPanel } from "./EventReservationPanel";
import { TableReservationPanel } from "./TableReservationPanel";

export const ReservationPanel = defineComponent({
  name: "ReservationPanel",
  props: {
    hideEvents: { type: Boolean, default: false },
  },
  setup(props) {
    const { selectedEvent } = useMenu();

    const hasEventSelected = computed(() => {
      return selectedEvent.value && selectedEvent.value.event;
    });

    return () => {
      if (hasEventSelected.value) {
        return <EventReservationPanel />;
      }

      return <TableReservationPanel hideEvents={props.hideEvents} />;
    };
  },
});
